import { Formik } from 'formik';
import React, { useState } from 'react';
import { sendUserInvite } from '../../../../api/manageTeam';
import { tailwindToast } from '../../../../components/Toast/tailwindToast';
import { CoreButton } from '@metaforcelabs/metaforce-core';

const actionResultType = {
  success: 0,
  failure: 1,
  warning: 2
};

export default function CreateInvite({ loading, initialValues, roles, onInviteCreated }) {
  const [inviteError, setInviteError] = useState(null);

  const sendInvite = async (values) => {
    setInviteError(null);

    try {
      const resultInvite = await sendUserInvite(values);

      if (resultInvite.type === actionResultType.success) {
        onInviteCreated();
      } else {
        tailwindToast.error(
          'License usage limit reached. Please change your license to invite new user.'
        );
      }
    } catch (error) {
      if (!error.response) {
        tailwindToast.error('Request failed');
        return;
      }

      const { status, data } = error.response;

      if (status === 400) {
        setInviteError(data.Message);
      }
    }
  };

  return (
    <div className="max-w-xl">
      {!loading && (
        <Formik
          initialValues={initialValues}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            sendInvite(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            resetForm
            /* and other goodies */
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={(e) => {
                resetForm();
              }}
            >
              <div className="grid grid-cols-1 gap-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Email
                  </label>
                  <div className="mt-2">
                    <input
                      type="email"
                      name="email"
                      required
                      value={values.email}
                      onChange={handleChange}
                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                </div>
                <div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Role
                    </label>
                    <div className="mt-2">
                      <select
                        name="customerUserRoleId"
                        value={values.customerUserRoleId}
                        onChange={handleChange}
                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      >
                        {roles.map((r) => {
                          return (
                            <option key={r.roleId} value={r.roleId}>
                              {r.roleName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="text-red-400">{inviteError}</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 sm:gap-x-8 gap-y-4">
                  <CoreButton
                      label={<div>Cancel</div>}
                      type="secondary"
                      htmlType="reset"
                      disabled={loading}
                  />
                  <CoreButton
                      label={<div>Invite</div>}
                      htmlType="submit"
                      disabled={isSubmitting}
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
}
